import type { RouteRecordRaw } from 'vue-router';

const privateRoutes: RouteRecordRaw = {
    path: '/dashboard',
    meta: {
        auth: true
    },
    redirect: '/dashboard',
    component: () => import('@/layout/AppLayout.vue'),
    children: [
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('@/views/Dashboard.vue')
        },
        {
            path: '/properties',
            name: 'properties',
            component: () => import('@/views/pages/properties/Properties.vue')
        },
        {
            path: '/leases',
            name: 'leases',
            component: () => import('@/views/pages/leases/Leases.vue')
        },
        {
            path: '/houses',
            name: 'houses',
            component: () => import('@/views/pages/houses/Houses.vue')
        },
        {
            path: '/payments',
            name: 'payments',
            component: () => import('@/views/pages/payments/Payments.vue')
        },
        {
            path: '/statements',
            name: 'Statements',
            component: () => import('@/views/pages/reports/Statements.vue')
        },
        {
            path: '/statements/aging-balances',
            name: 'AgingBalanceReport',
            component: () => import('@/views/pages/reports/AgingBalanceReport.vue')
        },
        {
            path: '/statements/user/:tenant_id?/:lease_id?',
            name: 'UserStatements',
            component: () => import('@/views/pages/reports/UserStatement.vue')
        },
        {
            path: '/statements/property',
            name: 'PropertyStatement',
            component: () => import('@/views/pages/reports/PropertyStatement.vue')
        },
        {
            path: '/tickets',
            name: 'tickets',
            component: () => import('@/views/pages/tickets/Tickets.vue')
        },
        {
            path: '/tickets/create',
            name: 'ticket-create',
            component: () => import('@/views/pages/tickets/TicketForm.vue')
        },
        {
            path: '/tickets/:id/edit',
            name: 'ticket-edit',
            component: () => import('@/views/pages/tickets/TicketForm.vue')
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import('@/views/pages/settings.vue')
        },
        {
            path: '/change-password',
            name: 'changePassword',
            component: () => import('@/views/pages/users/ChangePassword.vue')
        }
    ]
};

export default privateRoutes;